module.exports = __webpack_public_path__ + "assets/img/1a756be4f6594d0d5d9ac25558e8ddaf.webp";